// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2npeX","rootCenter":"LoadMoreObserver_rootCenter__1Bw6q","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__14_Uv"};